import rpc from '@square/dashboard-utilities/clients/rpc';
import { TeamService } from '@square/dashboard-protos/models/squareup/team_api/service';

// TODO: TFPLAT-506 Update TEAM_API_VERSION to EG SearchTeamMembers version once that
// is fully rolled out and stable
const TEAM_API_VERSION = '2021-05-13';
const additionalHeaders = new Map([['Square-Version', TEAM_API_VERSION]]);
export default TeamService.create(rpc(undefined, {
  additionalHeaders
}));